function initFancyBox() {
	var swiper, swiper2

	function doubleSliderSwiper() {
		if (document.querySelectorAll('.Thumbnail-slide__swiper-button') != null) {
			try {
				const swiperButton = document.querySelectorAll('.Thumbnail-slide__swiper-button')
				const swiperSlides = document.querySelectorAll('.Thumbnail-slide__swiper-slide[data-min-image]')
				const previewSlides = Number(document.querySelector('.Thumbnail-slide__swiper[data-preview-slides]').getAttribute('data-preview-slides'))
				let sumSlides = swiperSlides.length
				if (sumSlides <= previewSlides) {
					swiper = new Swiper('.Thumbnail-slide-swiper', {
						slidesPerView: 3,
						watchSlidesProgress: true,
						allowTouchMove: false,
						spaceBetween: 5,
						// thumbs: {
						// 	swiper: swiper2,
						// },
						breakpoints: {
							955: {
								spaceBetween: 12,
								slidesPerView: 5,
								allowTouchMove: false,
							},
							730: {
								spaceBetween: 12,
								allowTouchMove: false,
							},
							370: {
								spaceBetween: 12,
								allowTouchMove: true,
							},
							100: {
								allowTouchMove: true,
							},
						},
					})
					swiper2 = new Swiper('.Thumbnail-slide-swiper-2', {
						spaceBetween: 10,
						thumbs: {
							swiper: swiper,
						},
					})

					swiperButton.forEach(function (itemSwiperButton) {
						itemSwiperButton.classList.add('Vb--hidden')
					})

					swiper.on('swipee', function (swipe, event) {
						swiper2.slideTo(event.v, 0, false)
					})
				} else {
					swiper = new Swiper('.Thumbnail-slide-swiper', {
						slidesPerView: 3,
						watchSlidesProgress: true,
						allowTouchMove: false,
						spaceBetween: 5,
						navigation: {
							nextEl: '.Thumbnail-slide__swiper-button-next',
							prevEl: '.Thumbnail-slide__swiper-button-prev',
						},
						// thumbs: {
						// 	swiper: swiper2,
						// },
						breakpoints: {
							955: {
								spaceBetween: 12,
								slidesPerView: 5,
								allowTouchMove: false,
							},
							730: {
								spaceBetween: 12,
								allowTouchMove: false,
							},
							370: {
								spaceBetween: 12,
								allowTouchMove: true,
							},
							100: {
								allowTouchMove: true,
							},
						},
					})
					swiper2 = new Swiper('.Thumbnail-slide-swiper-2', {
						spaceBetween: 10,
						thumbs: {
							swiper: swiper,
						},
					})
					// swiper.on('click', function (swipe, event) {
					// 	swiper2.slideTo(swipe.clickedIndex, 0, true)
					// })
					swiper.on('swipee', function (swipe, event) {
						swiper2.slideTo(event.v, 0, false)
					})
				}
			} catch (err) {
			}
		}
	}

	doubleSliderSwiper()

	if (document.querySelector('.Thumbnail-slide') !== null) {
		$.extend(true, $.fancybox.defaults, {
			// ! Анимация открытия
			// false - отключить
			// "zoom" - увеличить изображение от / до миниатюры
			// "fade"
			// "zoom-in-out"
			animationEffect: 'zoom-in-out',

			// ! Анимация перехода между слайдами
			//   false            - disable
			//   "fade'
			//   "slide'
			//   "circular'
			//   "tube'
			//   "zoom-in-out'
			//   "rotate'
			transitionEffect: 'circular',

			// ! Анимация перехода между слайдами
			transitionDuration: 500,
			// ! Бесконечное прокручивание слайдов
			loop: true,
			// ! Переключение слайдов прокруткой мышью
			wheel: 'auto',
			// ! Защита слайдов (отключает правый щелчок мыши, чтобы не было возможности просмотреть код)
			protect: false,
			// ! Переключение с помощью клавиатуры
			keyboard: true,
			// ! Отключение/ включение стрелок переключения слайдов
			arrows: true,
			// ! Отключение/ включение Инфобара (это где пишется количество слайдов)
			infobar: true,
			// ! Отключение/ включение Тулбара (это где выбор элементов (лупа, скачать картинку и тд))
			toolbar: true,

			// ? Выбор активных кнопок в Тулбаре

			buttons: ['zoom', 'share', 'slideShow', 'fullScreen', 'download', 'thumbs', 'close'],

			// ? Русификатор кнопок (при наведение на них доп информация)

			lang: 'ru',
			i18n: {
				ru: {
					CLOSE: 'Закрыть',
					NEXT: 'Вперед',
					PREV: 'Назад',
					ERROR: 'Запрашиваемый контент не может быть загружен. <br/> Пожалуйста, попробуйте позже.',
					PLAY_START: 'Начать демонстрацию',
					PLAY_STOP: 'Приостановить демонстрацию',
					FULL_SCREEN: 'На полный экран',
					THUMBS: 'Миниатюры',
					DOWNLOAD: 'Скачать',
					SHARE: 'Поделиться',
					ZOOM: 'Увеличить',
				},
			},
			afterClose: function (close, event) {
				swiper.emit('swipee', { v: event.index })
			},
		})
	} else {
		$.extend(true, $.fancybox.defaults, {
			// ! Анимация открытия
			// false - отключить
			// "zoom" - увеличить изображение от / до миниатюры
			// "fade"
			// "zoom-in-out"
			animationEffect: 'zoom-in-out',

			// ! Анимация перехода между слайдами
			//   false            - disable
			//   "fade'
			//   "slide'
			//   "circular'
			//   "tube'
			//   "zoom-in-out'
			//   "rotate'
			transitionEffect: 'circular',

			// ! Анимация перехода между слайдами
			transitionDuration: 500,
			// ! Бесконечное прокручивание слайдов
			loop: true,
			// ! Переключение слайдов прокруткой мышью
			wheel: 'auto',
			// ! Защита слайдов (отключает правый щелчок мыши, чтобы не было возможности просмотреть код)
			protect: false,
			// ! Переключение с помощью клавиатуры
			keyboard: true,
			// ! Отключение/ включение стрелок переключения слайдов
			arrows: true,
			// ! Отключение/ включение Инфобара (это где пишется количество слайдов)
			infobar: true,
			// ! Отключение/ включение Тулбара (это где выбор элементов (лупа, скачать картинку и тд))
			toolbar: true,

			// ? Выбор активных кнопок в Тулбаре

			buttons: ['zoom', 'share', 'slideShow', 'fullScreen', 'download', 'thumbs', 'close'],

			// ? Русификатор кнопок (при наведение на них доп информация)

			lang: 'ru',
			i18n: {
				ru: {
					CLOSE: 'Закрыть',
					NEXT: 'Вперед',
					PREV: 'Назад',
					ERROR: 'Запрашиваемый контент не может быть загружен. <br/> Пожалуйста, попробуйте позже.',
					PLAY_START: 'Начать демонстрацию',
					PLAY_STOP: 'Приостановить демонстрацию',
					FULL_SCREEN: 'На полный экран',
					THUMBS: 'Миниатюры',
					DOWNLOAD: 'Скачать',
					SHARE: 'Поделиться',
					ZOOM: 'Увеличить',
				},
			},
		})
	}

	$('[data-fancybox-window]').fancybox({
		closeExisting: false,
		infobar: false,
		touch: false,
		toolbar: false,
		// afterClose: function () {
		//   //window.location = 'http://www.google.com/';
		// },
		// modal: false,
		// hideOnOverlayClick: true,
		// enableEscapeButton: true,
		// clickOutside: true,
		// closeExisting: false,
	})

	// New code
	$('[data-fancybox="live-photos-img"]').fancybox({
		loop: false,
		afterClose(instance) {
			const node = document.querySelector('.live-photos__swiper')
			node.swiper.slideTo(instance.currIndex)
		}
	})

	/* Если понадобится сделать на все галереи картонок */
	// $('[data-fancybox]').fancybox({
	// 	afterClose(instance) {
	// 		const node = instance.$trigger[0].closest('.swiper-container')
	// 		node.swiper.slideTo(instance.currIndex)
	// 	}
	// })
}
